import type ColorScheme from '../ColorScheme';
import { getOptimalTextColorString } from '../colorUtils';
import { getPaletteAsRawColors } from 'owa-theme';

/**
 * This function calculate optimal shades based on theme colors.
 * ex: When dark mode is on, neutralLighterAlt is dark- so getOptimalTextColorString returns brigther color.
 */
export default function getComposeOptimalColorStrings(colorScheme: ColorScheme): ColorScheme {
    if (colorScheme) {
        let optimalColorScheme = {} as ColorScheme;
        const whitePaletteAsRawColor = getPaletteAsRawColors().white;

        Object.keys(colorScheme).forEach(property => {
            if (typeof colorScheme[property] === 'string') {
                optimalColorScheme[property] = getOptimalTextColorString(
                    whitePaletteAsRawColor,
                    colorScheme,
                    colorScheme[property]
                );
            }
        });

        optimalColorScheme.accessibleText = colorScheme.accessibleText;

        return optimalColorScheme;
    }
    return null;
}
